import { createSlice } from '@reduxjs/toolkit';
import { getQueryString } from '../../../../domain/url-provider';
import { IFilterItem } from '../../../site-header/search-desktop/interfaces';
import { getJSONFromHtml } from '../../../../domain/common';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';

interface IState{
    query: string;
    filtered: IFilterItem[];
    isLoading: boolean;
}

const query = decodeURIComponent(getQueryString()['q'] ?? '');
const filtered = getJSONFromHtml(document.getElementById('initial-search-results')) || [];

const initialState: IState = {
    query,
    filtered,
    isLoading: false,
};

if(query.length > 1) {
    // q: {query} | rc: {number of results}
    // q: api | rc: 4
    sendGAEvent('SQLSearchQuery', `q: ${ query.toLowerCase() } | rc: ${ filtered.length }`);
}


const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },

        setQuery(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },
    }
});

export default rootSlice;